export default class Access {
  client
  ccs
  themes
  apiCCAccess
  apiRetextAccess
  chatAccess

  constructor(client = '', ccs = {}, themes = {}, apiCCAccess = false, apiRetextAccess = false, chatAccess = false) {
    this.client = client
    this.ccs = ccs
    this.themes = themes
    this.apiCCAccess = apiCCAccess
    this.apiRetextAccess = apiRetextAccess
    this.chatAccess = chatAccess
  }

  static NULL = new Access()
}
